import './ResultListDataCollectionGroupPanel.css'

import { Badge, Glyphicon, Table, tbody, thead } from 'react-bootstrap'

import { Link } from 'react-router-dom'
import React from 'react'
import ResultAnalysisToolsPlaceHolder from './ResultAnalysisToolsPlaceHolder.js'
import { convertToFixed } from '../../../../helpers/NumericTransformationsHelper.js'
import { getDownloadAutoprocessingFiles } from '../../../../api/ispyb.js'
import { rank } from '../../../../helpers/Mx/AutoprocessingRank.js'

export default class ResultListDataCollectionGroupPanel extends React.Component {
  /**
   * Given a comma separated string it return the fixed value at the index position
   * Example: statisticCommaseparatedArray=23,12,43,54 and index=3 then it should return 54
   * @param {*} statisticCommaseparatedArray
   * @param {*} index
   */
  getStatisticByIndex(statisticCommaseparatedArray, index) {
    if (statisticCommaseparatedArray) {
      return convertToFixed(statisticCommaseparatedArray.split(',')[index], 1)
    }
  }

  sortBy(results) {
    for (let i = 0; i < results.length; i++) {
      const result = results[i]
      if (result.scalingStatisticsType) {
        const types = result.scalingStatisticsType.split(',')
        for (let j = 0; j < types.length; j++) {
          result[types[j]] = {
            cchalf: this.getStatisticByIndex(result.ccHalf, j),
            resolutionLimitHigh: this.getStatisticByIndex(result.resolutionLimitHigh, j),
            resolutionLimitLow: this.getStatisticByIndex(result.resolutionLimitLow, j),
            multiplicity: this.getStatisticByIndex(result.multiplicity, j),
            completeness: this.getStatisticByIndex(result.completeness, j),
            meanIOverSigI: this.getStatisticByIndex(result.meanIOverSigI, j),
            rMeasAllIPlusIMinus: this.getStatisticByIndex(result.rMeasAllIPlusIMinus, j),
            rMeasWithinIPlusIMinus: this.getStatisticByIndex(result.rMeasWithinIPlusIMinus, j),
            rMerge: this.getStatisticByIndex(result.rMerge, j),
            rPimAllIPlusIMinus: this.getStatisticByIndex(result.rPimAllIPlusIMinus, j),
            rPimWithinIPlusIMinus: this.getStatisticByIndex(result.rPimWithinIPlusIMinus, j),
            sigAno: this.getStatisticByIndex(result.sigAno, j),
            ccAno: this.getStatisticByIndex(result.ccAno, j),
            isa: this.getStatisticByIndex(result.isa, j),
            anomalous: this.getStatisticByIndex(result.anomalous, j),
            anomalousCompleteness: this.getStatisticByIndex(result.anomalousCompleteness, j),
            anomalousMultiplicity: this.getStatisticByIndex(result.anomalousMultiplicity, j),
          }
        }
      }
    }

    return rank(results)
  }

  renderParameter(result, parameterName) {
    return (
      <div>
        <span className="overallShell">{result.overall[parameterName]}</span>
        <br />
        <span className="innerShell">{result.innerShell[parameterName]}</span>
        <br />
        <span className="outerShell">{result.outerShell[parameterName]}</span>
      </div>
    )
  }

  renderParameters(result, firstParameterName, sencodParameterName) {
    return (
      <div>
        <span className="overallShell">
          {result.overall[firstParameterName]} - {result.overall[sencodParameterName]}
        </span>
        <br />
        <span className="innerShell">
          {result.innerShell[firstParameterName]} - {result.innerShell[sencodParameterName]}
        </span>
        <br />
        <span className="outerShell">
          {result.outerShell[firstParameterName]} - {result.outerShell[sencodParameterName]}
        </span>
      </div>
    )
  }

  getDownloadAutoprocessingFilesURL(result) {
    return getDownloadAutoprocessingFiles(
      this.props.user,
      this.props.proposal,
      result.v_datacollection_summary_phasing_autoProcProgramId,
      result.DataCollection_imagePrefix +
        '_' +
        result.v_datacollection_summary_phasing_autoproc_space_group +
        '_' +
        result.v_datacollection_processingPrograms +
        '.zip'
    )
  }

  /** If running for a long long time is set as timeout */
  getProcessingStatus(value) {
    if (value.v_datacollection_processingStatus === 'RUNNING') {
      const startTime = new Date(value.v_datacollection_processingStartTime)
      const elapsed = Date.now() - startTime
      if (elapsed > 14400000) {
        // Four hours, 4*3600*1000
        return 'TIMEOUT'
      }
    }
    return value.v_datacollection_processingStatus
  }

  render() {
    const sortedResults = this.sortBy(this.props.results)
    return (
      <Table responsive striped bordered condensed hover>
        <thead>
          <tr>
            <th className="parameterValue" />
            <th className="parameterValue">SpG</th>
            <th className="parameterValue">a, b, c (Å)</th>
            <th className="parameterValue">α, β ,γ (°)</th>
            <th className="parameterValue">Shell</th>
            <th className="parameterValue">Res. (Å)</th>
            <th className="parameterValue">Mult.</th>
            <th className="parameterValue">Comp. %</th>
            <th className="parameterValue">I/Sigma</th>
            <th className="parameterValue">Rmeas</th>
            <th className="parameterValue">Rmerge</th>
            <th className="parameterValue">Rpim</th>
            <th className="parameterValue">cc(1/2)</th>
            <th className="parameterValue">ccAno</th>
            <th className="parameterValue">sigAno</th>
            <th className="parameterValue">ISA</th>
            <th className="parameterValue">Download</th>
          </tr>
        </thead>
        <tbody>
          {sortedResults.map(value => {
            const url = '/sessions/mx/proposal/:proposal/datacollection/:datacollectionid/autoprocintegration/:autoprocintegrationId'
              .replace(':proposal', this.props.proposal)
              .replace(':datacollectionid', this.props.dataCollectionId)
              .replace(':autoprocintegrationId', value.AutoProcIntegration_autoProcIntegrationId)

            if (
              value.v_datacollection_processingStatus === 'SUCCESS' ||
              value.v_datacollection_processingStatus === 1 ||
              value.v_datacollection_processingStatus === '1'
            ) {
              let anonmalousLabel = null
              if (value.v_datacollection_summary_phasing_anomalous) {
                anonmalousLabel = <Badge style={{ backgroundColor: '#337ab7' }}>ANOM</Badge>
              }
              return (
                <tr>
                  <td>
                    <span style={{ fontWeight: 'bold' }}>
                      <Link to={url}>{value.v_datacollection_processingPrograms}</Link>
                    </span>
                    <br />
                    <Badge style={{ backgroundColor: 'orange' }}>{value.label}</Badge>
                    <br />
                    {anonmalousLabel}
                    <p className="text-secondary" style={{ fontSize: '10px' }}>
                      id : {value.AutoProcIntegration_autoProcIntegrationId}
                    </p>
                  </td>

                  <td className="parameterKey">{value.v_datacollection_summary_phasing_autoproc_space_group}</td>
                  <td className="parameterKey">
                    {convertToFixed(value.v_datacollection_summary_phasing_cell_a, 1)}
                    <br />
                    {convertToFixed(value.v_datacollection_summary_phasing_cell_b, 1)}
                    <br />
                    {convertToFixed(value.v_datacollection_summary_phasing_cell_c, 1)}
                  </td>
                  <td className="parameterKey">
                    {value.v_datacollection_summary_phasing_cell_alpha}
                    <br />
                    {value.v_datacollection_summary_phasing_cell_beta}
                    <br />
                    {value.v_datacollection_summary_phasing_cell_gamma}
                  </td>
                  <td className="parameterKey">
                    <div>
                      <span className="overallShell">Overall</span>
                      <br />
                      <span className="innerShell">Inner</span>
                      <br />
                      <span className="outerShell">Outer</span>
                    </div>
                  </td>
                  <td className="parameterKey">
                    {this.renderParameters(value, 'resolutionLimitLow', 'resolutionLimitHigh')}
                  </td>
                  <td className="parameterKey">{this.renderParameter(value, 'multiplicity')}</td>
                  <td className="parameterKey">{this.renderParameter(value, 'completeness')}</td>
                  <td className="parameterKey">{this.renderParameter(value, 'meanIOverSigI')}</td>
                  <td className="parameterKey">{this.renderParameter(value, 'rMeasAllIPlusIMinus')}</td>
                  <td className="parameterKey">{this.renderParameter(value, 'rMerge')}</td>
                  <td className="parameterKey">{this.renderParameter(value, 'rPimAllIPlusIMinus')}</td>
                  <td className="parameterKey">{this.renderParameter(value, 'cchalf')}</td>
                  <td className="parameterKey">{this.renderParameter(value, 'ccAno')}</td>
                  <td className="parameterKey">{this.renderParameter(value, 'sigAno')}</td>
                  <td className="parameterKey">{this.renderParameter(value, 'isa')}</td>
                  <td>
                    <a href={this.getDownloadAutoprocessingFilesURL(value)}>
                      <Glyphicon glyph="download" />
                    </a>
                  </td>
                  <td>
                    <ResultAnalysisToolsPlaceHolder
                      configuration={this.props.configuration}
                      processDataCollection={this.props.processDataCollection}
                      jobs={this.props.jobs}
                      autoprocIntegration={value}
                    />
                  </td>
                </tr>
              )
            }
            return (
              <tr key={value.v_datacollection_summary_phasing_autoProcProgramId}>
                <td />
                <td className="parameterKey">{value.v_datacollection_processingPrograms}</td>
                <td className="parameterKey">{this.getProcessingStatus(value)}</td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }
}
